import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class LibraryClientsClientEditIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.replaceWith('library.clients.client.edit.general');
  }
}
